import { create } from "zustand";

// Pre-chart (VITE_PRE_CHART_ENABLED): "Start visit" in the visits list opens
// the draft and starts its recording. The list sets the visit here before
// navigating; the visit page takes it once and opens the recorder.
// A draft's template changed (PreChartTemplateChip, wherever it is shown):
// the workspace proposes the rewrite under the new headings.
export interface TemplateRewrite {
  key: number;
  visitPublicId: string;
  instruction: string;
}

export interface PreChartState {
  startVisitFor: string | null;
  requestStartVisit: (visitPublicId: string) => void;
  takeStartVisit: (visitPublicId: string) => boolean;
  templateRewrite: TemplateRewrite | null;
  requestTemplateRewrite: (visitPublicId: string, instruction: string) => void;
  takeTemplateRewrite: (key: number) => TemplateRewrite | null;
}

export const usePreChartStore = create<PreChartState>()((set, get) => ({
  startVisitFor: null,
  requestStartVisit: (visitPublicId) => set({ startVisitFor: visitPublicId }),
  takeStartVisit: (visitPublicId) => {
    if (get().startVisitFor !== visitPublicId) return false;
    set({ startVisitFor: null });
    return true;
  },
  templateRewrite: null,
  requestTemplateRewrite: (visitPublicId, instruction) =>
    set({ templateRewrite: { key: Date.now(), visitPublicId, instruction } }),
  takeTemplateRewrite: (key) => {
    const request = get().templateRewrite;
    if (!request || request.key !== key) return null;
    set({ templateRewrite: null });
    return request;
  },
}));
